import { render } from "./AddPreferredContractorModal.vue?vue&type=template&id=4b4d83f3&scoped=true&ts=true"
import script from "./AddPreferredContractorModal.vue?vue&type=script&lang=ts"
export * from "./AddPreferredContractorModal.vue?vue&type=script&lang=ts"

import "./AddPreferredContractorModal.vue?vue&type=style&index=0&id=4b4d83f3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4d83f3"]])

export default __exports__